import { render, staticRenderFns } from "./SysMenuEdit.vue?vue&type=template&id=a9e8ab88&scoped=true&"
import script from "./SysMenuEdit.vue?vue&type=script&lang=js&"
export * from "./SysMenuEdit.vue?vue&type=script&lang=js&"
import style0 from "./SysMenuEdit.vue?vue&type=style&index=0&id=a9e8ab88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e8ab88",
  null
  
)

export default component.exports